import { Component, Input, OnInit } from '@angular/core';
import { pairwise, startWith } from 'rxjs';

@Component({
    selector: 'app-staff-step-preview',
    templateUrl: './staff-step-preview.component.html',
    styleUrls: ['./staff-step-preview.component.scss'],
    standalone: false
})
export class StaffStepPreviewComponent implements OnInit {
  @Input() form: any = {};
  @Input() step: any;
  @Input() isEdit: boolean = false;

  public staffInformation:any = {};
  public staffDetail:any = {};
  public staffAddress:any ={}
  public salary:any ={}
  public staffCertificates:any ={}
  constructor() { }

  ngOnInit(): void {
    this.form.get('step01').valueChanges
    .pipe(startWith(null), pairwise())
    .subscribe(([prev, next]: [any, any]) => {
      this.staffInformation = next?.staffInformation;
    });

  this.form.get('step02').valueChanges
    .pipe(startWith(null), pairwise())
    .subscribe(([prev, next]: [any, any]) => {
      this.staffDetail = next?.staffDetail;
      console.log('nextstep02', this.staffDetail);
    });

  this.form.get('step03').valueChanges
    .pipe(startWith(null), pairwise())
    .subscribe(([prev, next]: [any, any]) => {
      this.staffAddress = next?.staffAddress;
    });

  this.form.get('step04').valueChanges
    .pipe(startWith(null), pairwise())
    .subscribe(([prev, next]: [any, any]) => {
      this.salary = next?.salary;
    });

    this.form.get('step05').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.staffCertificates = next?.certifications;
        console.log('next',this.staffCertificates);
      });
  }


  getFileName(image: any) {
    const urlParts = image.split('/');
    return urlParts[urlParts.length - 1];
  }
}
